import { ValueFormatterParams } from 'ag-grid-enterprise'

import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { ManagementReport } from '@fortem-monorepo/web-sdk'

import { useManagementReportQuery } from '@/pages/funds/management-report/query'
import { ManagementReportWidget } from '@/pages/funds/management-report/types'
import { formatNumber } from '@/utilities/format'

export interface RiskGridProps extends ManagementReportWidget {}

export const RiskGrid: React.FC<RiskGridProps> = ({ params }) => {
  const query = useManagementReportQuery(params)

  return (
    <Widget>
      <WidgetHeaderWithQuery query={query} title="Risk" />
      <WidgetContent loading={query.isLoading}>
        <CustomAgGrid
          query={query}
          rowData={query.data?.risk}
          columnDefs={makeColDefs()}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}

const makeColDefs = () => {
  return createColDefs<Required<ManagementReport.GetManagementReportData>['risk'][number]>([
    {
      field: 'index',
      headerName: '',
    },
    {
      field: '1_year',
      headerName: '1Y',
      valueFormatter: valueFormatter,
      cellClass: 'text-center',
    },
    {
      field: '3_year',
      headerName: '3Y',
      valueFormatter: valueFormatter,
      cellClass: 'text-center',
    },
  ])
}

const valueFormatter = (
  params: ValueFormatterParams<Required<ManagementReport.GetManagementReportData>['risk'][number]>,
) => {
  if (typeof params.value !== 'number') return params.value

  switch (params.data?.index) {
    case 'Annualised Volatility':
    case 'Max Drawdown':
      return formatNumber(params.value * 100, { suffix: '%', decimalPlaces: 2 })
    default:
      return formatNumber(params.value, { decimalPlaces: 2 })
  }
}
